import React from 'react';
import { IMaskMixin } from 'react-imask';
import { StyledTextField } from './fields';

const IMaskInput = IMaskMixin(({ inputRef, ...props }) => {
  const { classes, ...otherProps } = props;

  return <StyledTextField {...otherProps} inputRef={inputRef} />;
});

const MaskedInput = ({ name, onChange, value, mask, ...otherProps }) => {
  return <IMaskInput name={name} mask={mask} value={value} {...otherProps} />;
};
export default MaskedInput;
